import { type ComponentPropsWithoutRef, createElement } from "react";

import { useUser } from "@components/user-context";
import { formatting, type metrics } from "@north-beam/nb-common";

type Props<T extends "div" | "span" | "p"> = {
  as?: T;
  value: number | null | undefined;
  format: metrics.MetricType;
  precision?: formatting.MetricPrecision;
} & ComponentPropsWithoutRef<T>;

export const MetricValue = <T extends "div" | "span" | "p">({
  as = "div" as T,
  value,
  format,
  precision = "exact",
  ...props
}: Props<T>) => {
  const { user } = useUser();

  return (
    <>
      {createElement(
        as,
        props,
        formatting.formatMetric(value, format, {
          precision,
          code: user.currencies.currentCurrency,
        }),
      )}
    </>
  );
};
